import { DatabaseOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Col, Empty, Modal, Row, Space, notification } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { emit, on } from '@/socket';
import { fetchTranslationGroup } from '@/shared/store/userSlice';
import { HEIGHT_VALUES, SPAN_CHANGER } from '@/shared/utils/consts';
import CustomReactFlvPlayer from '@/shared/components/WrapperReactFlvPlayer/ReactFlvPlayer';
import AddUserModal from './AddUserModal.component';
import UserListModal from './UserListModal.component';
import './index.css';
import { api } from '@/shared/api/api';

const GroupTranslationsContent = () => {
  const dispatch = useDispatch();
  const [notificationApi, contextHolder] = notification.useNotification();
  const { userId, name, email } = useSelector(state => state.userInfo.userState);
  const translationGroup = useSelector(state => state.userInfo.translationGroup);
  const devicesToShow = useSelector(state => state.userInfo.streamingDevices);
  const [visualButtons, setVisualButtons] = useState(false);
  const [usersWithCorrectAccess, setusersWithCorrectAccess] = useState([]);
  const [isRoomCreator, setIsRoomCreator] = useState(false);
  const [spectators, setSpectators] = useState([]);
  const [allStreams, setAllStreams] = useState([]);
  const [showStreams, setShowStreams] = useState([]);
  const [streamsIsLive, setStreamsIsLive] = useState([]);
  const [isStreamModalOpen, setStreamModalOpen] = useState(false);

  const abortControllerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const apiSuccess = (message, description) => ({
    message,
    description,
    placement: 'topRight',
  });

  // Получение выбранных стримов из localStorage
  useEffect(() => {
    const savedStreams = localStorage.getItem('selectedStreams');
    if (savedStreams) {
      setShowStreams(JSON.parse(savedStreams));
    }
  }, []);

  useEffect(() => {
    if (!showStreams?.length) return;

    localStorage.setItem('selectedStreams', JSON.stringify(showStreams));
  }, [showStreams]);

  // Инициализация группы и получение данных
  useEffect(() => {
    const savedGroup = localStorage.getItem('translationGroup');
    if (savedGroup) {
      dispatch(fetchTranslationGroup());
      setVisualButtons(true);
      if (+savedGroup.replace('room-', '') === userId) {
        setIsRoomCreator(true);
        fetchUserWithAccess();
        effectFunc();
      }
      fetchUsersList();
    }
  }, [dispatch, userId]);

  useEffect(() => {
    setAllStreams(devicesToShow ? [...devicesToShow] : []);
  }, [devicesToShow]);

  useEffect(() => {
    on('join_request', roomId => {
      emit('join-room', roomId);
      dispatch(fetchTranslationGroup());
      setVisualButtons(true);
      localStorage.setItem('translationGroup', roomId);
    });

    on('reject_request', data => {
      notificationApi.success(
        apiSuccess(`Невозможно добавить пользователя`, `Пользователь ${data} уже состоит в какой-то группе!`)
      );
    });

    on('changed-checkboxed', data => {
      setAllStreams(data);
    });

    on('startData', data => {
      setAllStreams(data);
    });

    on('updateList', () => {
      fetchUsersList();
    });

    on('leave-now', () => {
      notificationApi.error(apiSuccess(`Групповая трансляция`, `Вы были исключены создателем группы!`));
      leaveRoom();
    });

    on('adminLeaved', () => {
      // Вместо перезагрузки вызываем функцию leaveRoom для обновления состояния
      leaveRoom();
    });

    on('showInfoMessage', text => {
      notificationApi.info(apiSuccess('Уведомление', text));
    });

    if (typeof translationGroup === 'string') {
      fetchUsersList();
      setVisualButtons(true);
      emit('checkTranslations-onOpen');
    }
  }, [translationGroup]);

  useEffect(() => {
    if (typeof translationGroup === 'string' && +translationGroup.replace('room-', '') === userId) {
      fetchUsersList();
      emit('checkTranslations-onOpen');
      setIsRoomCreator(true);
      setVisualButtons(true);
      fetchUserWithAccess();
      effectFunc();
    } else if (typeof translationGroup === 'string') {
      fetchUsersList();
      setAllStreams([...devicesToShow]);
      setVisualButtons(true);
      emit('checkTranslations-onOpen');
    }
  }, [translationGroup, devicesToShow, userId]);

  useEffect(() => {
    console.log(showMedia(showStreams.length));
    setStreamsIsLive(showMedia(showStreams.length));
  }, [allStreams, showStreams]);

  const notificationSuccess = (message, description, status) => {
    switch (status) {
      case 200:
        notificationApi.success(apiSuccess(message, description));
        setVisualButtons(true);
        break;
      case 400:
        notificationApi.error(apiSuccess(message, description));
        break;
      default:
        break;
    }
  };

  const fetchUsersList = async () => {
    try {
      const { data: usersList } = await api.get(`api/group_translation/get_actual_users?user_id=${userId}`);
      setSpectators(usersList.data);
    } catch (error) {
      console.error('Ошибка получения списка пользователей:', error);
    }
  };

  const fetchUserWithAccess = async () => {
    try {
      const { data: receivedUsers } = await api.get('/api/group_translation/get_users_with_access');
      setusersWithCorrectAccess(
        receivedUsers.data.map(el => ({
          label: el.name || el.email,
          value: el.id,
        }))
      );
    } catch (error) {
      console.error('Ошибка получения пользователей с доступом:', error);
    }
  };

  const removeUser = user => {
    emit('remove_from_room', user);
    fetchUsersList();
  };

  const handleAddUserModalOk = async values => {
    try {
      if (!values.names || values.names.length === 0) {
        return notificationApi.error(apiSuccess('Ошибка', 'Выберите хотя бы одного пользователя!'));
      }
      const { data: groupRes } = await api.get(`/api/group_translation/get_active_group?userId=${userId}`);
      if (!groupRes || !groupRes.room_db_id) {
        return notificationApi.error(apiSuccess('Ошибка', 'Группа не найдена'));
      }
      const groupId = groupRes.room_db_id;
      const { data: res } = await api.post('/api/group_translation/add_users_to_group', {
        groupId,
        users: values.names,
      });
      if (res.status === 200) {
        notificationApi.success(apiSuccess('Успешно', 'Пользователи добавлены в группу'));
        fetchUsersList();
        if (values.names && values.names.length > 0) {
          emit('join_group', values.names);
        }
      } else {
        notificationApi.error(apiSuccess('Ошибка', res.message));
      }
    } catch (error) {
      console.error('Ошибка добавления пользователей:', error);
      notificationApi.error(apiSuccess('Ошибка', 'Не удалось добавить пользователей'));
    }
  };

  // ------------- Логика трансляций -------------
  const getFullListStreams = () =>
    allStreams
      ? [
          ...allStreams.filter(el => !showStreams.some(stream => stream.device_id === el.device_id)),
          ...(showStreams ?? []),
        ].filter(el => Object.keys(el).length !== 0)
      : [];

  const effectFunc = async () => {
    await getAllStreams();
    on('update_translate', async () => {
      console.log('Получен update_translate');
      await getAllStreams();
    });
  };

  const getAllStreams = async () => {
    try {
      const { data: response } = await api.get('/api/streams/list');
      setAllStreams(response);
    } catch (error) {
      console.error('Ошибка получения списка стримов:', error);
    }
  };

  const showTranslation = async el => {
    try {
      if (showStreams?.some(stream => stream.device_id === el.device_id)) {
        if (isRoomCreator) {
          emit('close-translation', el.device_id);
        }
        setShowStreams(showStreams.filter(stream => stream.device_id !== el.device_id));
      } else {
        if (isRoomCreator) {
          emit('show-translation', [...showStreams, el]);
        }
        setShowStreams([...showStreams, el]);
      }
    } catch (err) {
      setShowStreams(showStreams.filter(stream => stream.device_id !== el.device_id));
      console.log(`showTranslation error: ${err}`);
    }
  };

  const checkBoxGenerator = el => {
    if (isRoomCreator) {
      emit('add_remove_translations', { showStreams, translationGroup });
    }
    return (
      <Checkbox
        checked={showStreams?.some(streamIsShow => streamIsShow.device_id === el.device_id)}
        disabled={
          showStreams.length > 8 ? !showStreams?.some(streamIsShow => streamIsShow.device_id === el.device_id) : false
        }
        style={{
          backgroundColor: '#F5F5F5',
          width: '100%',
          height: '100%',
        }}
        onClick={() => showTranslation(el)}
      >
        <b style={{ fontSize: '1.3em' }}>{getTitle(el)}</b>
      </Checkbox>
    );
  };

  const showMedia = length =>
    showStreams.map((el, i) => {
      return (
        <Col key={i} span={SPAN_CHANGER[length]} order={2}>
          <Card size='small' title={getTitle(el)}>
            {allStreams?.some(stream => stream.device_id === el.device_id) ? (
              <CustomReactFlvPlayer
                url={`/translation/live/${el.device_id}.flv/${el.creds}`}
                height={HEIGHT_VALUES[length]}
              />
            ) : (
              <div style={{ height: HEIGHT_VALUES[length], color: 'red' }}>Трансляция недоступна</div>
            )}
          </Card>
        </Col>
      );
    });

  const getTitle = el => {
    if (Object.keys(el).length !== 0) {
      return el.call_sign || el.device_id;
    }
    return null;
  };

  const createGroup = async () => {
    const groupId = `room-${userId}`; // Генерируем groupId
    try {
      const { data: createRoom } = await api.post('/api/group_translation/create_group', { userId, groupId });

      if (createRoom.status === 300) {
        dispatch(fetchTranslationGroup());
        emit('join-room', createRoom.groupId);
        setVisualButtons(true);
        localStorage.setItem('translationGroup', createRoom.groupId);
        return;
      }

      dispatch(fetchTranslationGroup());
      emit('join-room', groupId);
      setVisualButtons(true);
      localStorage.setItem('translationGroup', groupId);
      return notificationSuccess(createRoom.message, null, createRoom.status);
    } catch (error) {
      console.error('Ошибка создания группы:', error);
      notificationApi.error(apiSuccess('Ошибка', 'Не удалось создать группу'));
    }
  };

  const leaveRoom = async () => {
    emit('leave-room', { user: name || email });
    setVisualButtons(false);
    setIsRoomCreator(false);
    setShowStreams([]);
    setAllStreams([]);
    localStorage.removeItem('selectedStreams');
    localStorage.removeItem('translationGroup');
    setSpectators([]);
  };

  return (
    <>
      {contextHolder}
      <div className='top-controls'>
        {!visualButtons ? (
          <Button onClick={createGroup} type='primary'>
            Создать
          </Button>
        ) : (
          <>
            <div className='left-controls'>
              {isRoomCreator && <AddUserModal onFinish={handleAddUserModalOk} usersOptions={usersWithCorrectAccess} />}
              <UserListModal
                spectators={spectators}
                isRoomCreator={isRoomCreator}
                removeUser={removeUser}
                translationGroup={translationGroup}
              />
              <Button type='primary' icon={<DatabaseOutlined />} onClick={() => setStreamModalOpen(true)}>
                Выбрать стримы
              </Button>
            </div>
            <div className='right-controls'>
              <Button type='primary' danger onClick={leaveRoom}>
                Выйти
              </Button>
            </div>
          </>
        )}
      </div>
      <Modal title='Выберите стримы' open={isStreamModalOpen} onCancel={() => setStreamModalOpen(false)} footer={null}>
        <div className='stream-modal-content'>
          {getFullListStreams().map((el, i) => (
            <Space key={i}>{checkBoxGenerator(el)}</Space>
          ))}
        </div>
      </Modal>
      <div className='content'>
        <Row>{streamsIsLive.map(el => el)}</Row>
        {getFullListStreams().length === 0 && streamsIsLive.length === 0 && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Empty description='Нет доступных трансляций' />
          </div>
        )}
      </div>
    </>
  );
};

export default GroupTranslationsContent;
